import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

import {
  subscriptionManagement,
  paymentMethod,
  testOpsPlatformPaymentStatus,
  testOpsPlatformCheckout,
  retryPayment,
} from '../layout/routes';

const commerceEnginePaths = [
  subscriptionManagement.path,
  paymentMethod.path,
  testOpsPlatformPaymentStatus.path,
  testOpsPlatformCheckout.path,
  retryPayment.path,
];
/**
 * BE CAREFUL: this is dedicated for Commerce Engine
 * It must be used inside layout/index.tsx because it depends on Route variables
 */
export const useCommerceEngineSentryHook = () => {
  useEffect(() => {
    Sentry.init({
      environment: process.env.REACT_APP_SENTRY_ENV,
      dsn: process.env.REACT_APP_SENTRY_DNS,
      integrations: [
        Sentry.browserApiErrorsIntegration({
          XMLHttpRequest: true,
        }),
        Sentry.httpClientIntegration(),
        Sentry.browserTracingIntegration(),
      ],
      tracesSampleRate: 1.0,
      beforeSendTransaction(event) {
        if (commerceEnginePaths.find(cePath => event.transaction?.includes(cePath))) {
          return event;
        }

        return null;
      },
    });
  }, []);
};
